// Sorting function for sorting productData based on price
export const sortProduct = (productData) => {
    return productData.slice().sort((a, b) => a.idTrimItem - b.idTrimItem);
}
